function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs6"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath18",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path16",
  d: "M 0,400 H 550 V 0 H 0 Z"
})));

var SvgLogoWhiteSvg = function SvgLogoWhiteSvg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 733.33331 533.33331",
    height: 533.33331,
    width: 733.33331,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,533.33333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.1504,291.9502)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 3.267,3.267 7.217,4.9 11.85,4.9 4.599,0 8.517,-1.633 11.75,-4.9 3.267,-3.267 4.9,-7.2 4.9,-11.8 0,-4.6 -1.633,-8.533 -4.9,-11.8 -3.233,-3.267 -7.151,-4.9 -11.75,-4.9 -4.633,0 -8.583,1.633 -11.85,4.9 -3.233,3.267 -4.85,7.2 -4.85,11.8 0,4.6 1.617,8.533 4.85,11.8 m 195.999,29.15 c -2.966,-3 -4.449,-6.6 -4.449,-10.8 0,-3.067 0.783,-5.8 2.349,-8.2 -10.933,-12.7 -23.65,-25.067 -38.15,-37.1 15.101,8.6 29.65,19.25 43.65,31.95 2.201,-1.233 4.651,-1.85 7.35,-1.85 4.2,0 7.784,1.483 10.75,4.45 2.967,2.967 4.45,6.55 4.45,10.75 0,4.2 -1.483,7.8 -4.45,10.8 -2.966,2.967 -6.55,4.45 -10.75,4.45 -4.199,0 -7.783,-1.483 -10.75,-4.45 m -12.649,12.4 c 6.5,6.5 14.349,9.75 23.549,9.75 9.201,0 17.05,-3.25 23.55,-9.75 6.5,-6.5 9.75,-14.35 9.75,-23.55 0,-9.2 -3.25,-17.05 -9.75,-23.55 -6.5,-6.5 -14.349,-9.75 -23.55,-9.75 -3.933,0 -7.616,0.583 -11.049,1.75 C 153.916,-53.583 92.516,-87.067 11.65,-114 c -77.433,-24.4 -129.683,-26.667 -156.75,-6.8 -11.233,10.166 -14.6,23.95 -10.1,41.35 1.3,3.5 2.617,5.017 3.95,4.55 1.4,-0.5 1.933,-2 1.6,-4.5 -1.667,-31.267 31.7,-39.567 100.099,-24.9 86.7,21.7 161.667,58.817 224.901,111.35 -1.201,3.4 -1.8,7.05 -1.8,10.95 0,9.2 3.266,17.05 9.8,23.55"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(460.3496,310.0503)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,2.633 -0.717,4.983 -2.149,7.05 -4.517,0.017 -9.416,-6.167 -16.85,-11.5 c 1.4,-0.567 2.916,-0.85 4.55,-0.85 3.401,0 6.3,1.217 8.7,3.65 C -1.2,-6.3 0,-3.4 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(523.75,72.0498)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -1.101,-2.066 -2.65,-3.716 -4.65,-4.949 -1.967,-1.167 -4.267,-1.767 -6.9,-1.801 -2.634,0.034 -4.95,0.634 -6.95,1.801 -1.967,1.233 -3.517,2.883 -4.65,4.949 -1.1,2.101 -1.666,4.534 -1.701,7.301 0.035,2.766 0.601,5.233 1.701,7.399 1.133,2.101 2.7,3.767 4.7,5 2,1.2 4.3,1.8 6.9,1.8 2.633,0 4.933,-0.6 6.9,-1.8 2,-1.2 3.549,-2.849 4.65,-4.95 C 1.133,12.584 1.7,10.101 1.7,7.301 1.7,4.534 1.133,2.101 0,0 M 1.7,46.2 V 21.601 c -1.567,2.533 -3.634,4.483 -6.2,5.849 -2.601,1.367 -5.65,2.05 -9.15,2.05 -4.1,0 -7.684,-0.916 -10.75,-2.75 -3.1,-1.833 -5.5,-4.399 -7.201,-7.699 -1.733,-3.234 -2.616,-7.051 -2.649,-11.45 0.033,-4.401 0.916,-8.25 2.649,-11.55 1.701,-3.334 4.101,-5.934 7.201,-7.801 3.1,-1.833 6.75,-2.767 10.95,-2.8 3.433,0.033 6.433,0.7 9,2 2.566,1.334 4.616,3.267 6.15,5.8 v -7.399 h 9.4 V 46.2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(466.0498,101.5)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -3.7,0.033 -6.884,-0.666 -9.55,-2.1 -2.7,-1.367 -4.834,-3.549 -6.4,-6.549 V -0.35 H -25.3 V -43.6 h 9.35 v 23 c 0.334,3.434 1.566,6.234 3.7,8.4 2.1,2.167 4.967,3.301 8.6,3.4 3.266,-0.033 5.817,-0.967 7.65,-2.8 1.8,-1.834 2.717,-4.4 2.75,-7.7 v -24.3 h 9.35 v 26.9 c -0.067,5.233 -1.5,9.317 -4.3,12.25 C 9,-1.55 5.066,-0.066 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.8496,69.2998)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -2.366,-2.566 -5.533,-3.866 -9.5,-3.899 -3.967,0.033 -7.149,1.333 -9.55,3.899 -2.4,2.5 -3.634,5.867 -3.7,10.101 0.066,4.233 1.3,7.616 3.7,10.149 2.401,2.5 5.583,3.801 9.55,3.9 3.967,-0.099 7.134,-1.4 9.5,-3.9 C 2.4,17.717 3.634,14.334 3.7,10.101 3.634,5.867 2.4,2.5 0,0 m 2.3,29.4 c -3.4,1.8 -7.333,2.734 -11.8,2.8 -4.5,-0.066 -8.434,-1 -11.8,-2.8 -3.4,-1.833 -6.033,-4.383 -7.9,-7.65 -1.933,-3.3 -2.9,-7.133 -2.9,-11.5 0,-4.399 0.967,-8.233 2.9,-11.5 1.867,-3.267 4.5,-5.816 7.9,-7.649 3.366,-1.868 7.3,-2.817 11.8,-2.851 4.467,0.034 8.4,0.983 11.8,2.851 3.367,1.833 5.983,4.382 7.85,7.649 1.9,3.267 2.867,7.101 2.9,11.5 -0.033,4.367 -1,8.2 -2.9,11.5 -1.867,3.267 -4.483,5.817 -7.85,7.65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420.7002,73.1006)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.301,-2.4 -1.567,-4.351 -3.801,-5.851 -2.233,-1.533 -5.066,-2.333 -8.5,-2.399 -2.633,0.033 -4.682,0.616 -6.149,1.75 -1.434,1.133 -2.184,2.699 -2.25,4.699 0,2.034 0.733,3.517 2.2,4.45 1.466,0.901 3.733,1.334 6.8,1.3 H 0 Z m 4.55,24.35 c -2.967,2.633 -7.25,3.983 -12.851,4.049 -2.733,0 -5.116,-0.216 -7.149,-0.649 -2.067,-0.4 -4.017,-1 -5.851,-1.801 -1.766,-0.833 -3.649,-1.833 -5.649,-3 l 3.849,-6.5 c 2.134,1.467 4.284,2.551 6.451,3.25 2.133,0.734 4.25,1.101 6.349,1.101 3.401,0 5.967,-0.767 7.7,-2.3 C -0.867,17 0,14.866 0,12.1 v -1.35 h -13.101 c -5.233,-0.067 -9.25,-1.233 -12.049,-3.5 -2.833,-2.334 -4.267,-5.483 -4.3,-9.45 0.033,-2.601 0.666,-4.884 1.899,-6.851 1.2,-2.033 2.934,-3.633 5.2,-4.8 2.3,-1.132 5,-1.716 8.101,-1.75 3.166,0 5.966,0.467 8.399,1.401 2.401,0.933 4.384,2.349 5.951,4.25 V -15.2 H 9.25 L 9.199,13.149 C 9.1,17.949 7.55,21.683 4.55,24.35"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 372.95,57.9 h 9.399 v 60.35 h -9.399 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.7505,68.4502)",
    id: "g46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.901,-0.267 -1.733,-0.4 -2.5,-0.4 -1.301,-0.067 -2.284,0.284 -2.95,1.05 -0.701,0.8 -1.05,2.034 -1.05,3.7 v 17.2 H 4.949 V 30.8 H -6.5 v 12.1 h -14 V 30.7 h -6.1 v -9.15 h 6.1 V 2.15 c 0.033,-3 0.667,-5.534 1.9,-7.6 1.233,-2.067 2.949,-3.633 5.15,-4.7 2.133,-1.034 4.633,-1.55 7.5,-1.55 2.133,0 4.217,0.25 6.25,0.75 2,0.533 3.817,1.266 5.45,2.2 L 3,1.05 C 1.9,0.616 0.9,0.267 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.5,86.5)",
    id: "g50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -2.334,-1.899 -5.717,-2.85 -10.15,-2.85 H -22.851 V 19.7 H -10.15 C -5.717,19.7 -2.334,18.783 0,16.95 2.366,15.15 3.566,12.384 3.6,8.65 3.566,4.783 2.366,1.9 0,0 M 6.899,23.25 C 3,26.584 -2.55,28.267 -9.75,28.3 h -22.7 v -56.9 h 9.599 v 17.15 H -9.75 c 7.2,0.034 12.75,1.817 16.649,5.35 3.868,3.534 5.818,8.534 5.851,15 -0.033,6.201 -1.983,10.984 -5.851,14.35"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.1504,69.4004)",
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -1.533,-0.834 -3.301,-1.25 -5.301,-1.25 -2.766,0.033 -4.982,1.033 -6.649,3 -1.633,2 -2.484,4.717 -2.55,8.149 0.066,3.334 0.917,5.984 2.55,7.951 1.667,2 3.883,3.016 6.649,3.049 1.934,0 3.634,-0.399 5.101,-1.199 1.5,-0.766 2.766,-1.867 3.8,-3.301 l 10.05,6.051 c -1.967,3.166 -4.617,5.6 -7.951,7.3 -3.332,1.666 -7.182,2.517 -11.549,2.55 -4.567,-0.033 -8.55,-0.984 -11.951,-2.85 -3.399,-1.867 -6.049,-4.467 -7.949,-7.801 -1.9,-3.366 -2.85,-7.316 -2.85,-11.849 0,-4.5 0.95,-8.417 2.85,-11.75 1.867,-3.3 4.483,-5.884 7.85,-7.75 3.4,-1.833 7.349,-2.767 11.849,-2.8 4.668,0.033 8.718,0.934 12.151,2.7 3.367,1.734 5.966,4.234 7.8,7.5 L 3.65,3.7 C 2.717,2.033 1.5,0.8 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.4004,72.25)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.5,-1.8 -1.567,-3.25 -3.2,-4.35 -4.867,-5.416 -6.801,-5.967 -9,-6 c -1.967,0.033 -3.483,0.5 -4.551,1.4 -1.099,0.934 -1.649,2.201 -1.649,3.8 0,1.6 0.533,2.783 1.6,3.55 1.067,0.767 2.65,1.15 4.75,1.15 H 0 Z m 8.75,25.45 c -3.301,2.767 -7.967,4.167 -14,4.2 -3.633,0 -7.083,-0.433 -10.35,-1.299 -3.3,-0.834 -6.633,-2.051 -10,-3.651 l 3.95,-9.3 c 2.367,1.201 4.683,2.1 6.95,2.701 2.266,0.666 4.317,1 6.149,1 C -5.717,19.066 -3.583,18.434 -2.15,17.2 -0.717,16 0,14.3 0,12.101 V 11.5 h -11.551 c -5.466,-0.1 -9.633,-1.283 -12.499,-3.55 -2.867,-2.333 -4.317,-5.583 -4.35,-9.75 0.033,-2.7 0.65,-5.066 1.85,-7.099 1.2,-2.068 2.917,-3.684 5.15,-4.851 2.267,-1.166 4.95,-1.75 8.05,-1.75 3,0 5.633,0.483 7.9,1.45 2.266,0.934 4.117,2.35 5.55,4.25 v -5.05 H 13.8 V 13.8 c -0.067,5 -1.75,8.884 -5.05,11.65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.5005,83.0498)",
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.433,2.7 1.45,4.834 3.05,6.4 4.617,8.034 6.633,8.867 9.1,8.9 11.667,8.867 13.7,8.051 15.2,6.45 16.733,4.884 17.517,2.733 17.55,0 Z M 21.75,15.45 C 18.35,17.551 14.066,18.617 8.9,18.65 4.367,18.617 0.383,17.684 -3.05,15.851 -6.45,13.983 -9.1,11.367 -11,8 c -1.934,-3.333 -2.917,-7.283 -2.95,-11.85 0.033,-4.5 0.983,-8.417 2.85,-11.75 1.867,-3.299 4.55,-5.883 8.05,-7.75 3.467,-1.833 7.6,-2.766 12.4,-2.799 4.033,0.033 7.667,0.716 10.9,2.049 3.2,1.333 5.917,3.217 8.15,5.651 l -7.35,7.3 c -1.5,-1.5 -3.15,-2.618 -4.95,-3.351 -1.767,-0.767 -3.617,-1.149 -5.55,-1.149 -2.6,0 -4.8,0.7 -6.6,2.099 -1.767,1.401 -3,3.417 -3.7,6.05 h 30.8 c 0.3,5.334 -0.318,9.967 -1.85,13.9 -1.6,3.867 -4.083,6.884 -7.45,9.05"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.9004,87.1504)",
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -1.7,-1.566 -4.133,-2.351 -7.3,-2.351 H -18.25 V 15.8 H -7.3 c 3.167,0 5.6,-0.767 7.3,-2.3 C 1.733,12.033 2.6,9.816 2.6,6.85 2.6,3.816 1.733,1.533 0,0 M 13.7,-3.851 C 15.467,-0.75 16.367,2.967 16.4,7.3 16.333,13.7 14.267,18.6 10.2,22 6.133,25.434 0.3,27.149 -7.3,27.149 H -32.75 V -29.75 h 14.5 v 16 H -6.9 l 8.5,-16 H 18 L 6.05,-11 c 3.333,1.666 5.883,4.05 7.65,7.149"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(460.3496,310.0503)",
    id: "g70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,-3.4 -1.2,-6.3 -3.6,-8.7 -2.4,-2.433 -5.299,-3.65 -8.7,-3.65 -1.634,0 -3.15,0.283 -4.55,0.85 C -9.416,-6.167 -4.517,0.017 -2.149,7.05 -0.717,4.983 0,2.633 0,0"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoWhiteSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-white-svg.b665baae.svg";
export { ForwardRef as ReactComponent };